const profileValidationIT = {
    "email": {
        "required": "L'indirizzo email è richiesto"
    },
    "profile_image": {
        "dimensions": "La dimensione dell'immagine del profilo deve essere esattamente 300 x 300 px, JPG/JPEG. Dimensione massima del file 300 KB",
        "choose": "Si prega di scegliere un'immagine",
        "file": "Il file selezionato è più grande di 300 KB. Si prega di caricare una copertina in 300x300 px, JPG/JPEG, dimensione massima del file 300 KB."
    },
    "street_and_number": {
        "required": "La via e il numero civico sono richiesti"
    },
    "postal_code": {
        "required": "Il codice postale è richiesto"
    },
    "city": {
        "required": "La città è richiesta"
    },
    "country": {
        "required": "Il paese è richiesto"
    },
    "vat_number": {
        "invalid": "Il valore non è un numero di partita IVA valido"
    },
    "iban": {
        "required": "IBAN è richiesto",
        "invalid": "Il valore non è un numero IBAN valido"
    },
    "cardholder_name": {
        "required": "Il nome del titolare della carta è richiesto"
    },
    "card_number": {
        "required": "Il numero della carta è richiesto",
        "invalid": "Il numero della carta non è valido"
    },
    "card_year": {
        "required": "L'anno di scadenza è richiesto",
        "invalid": "L'anno di scadenza non è valido"
    },
    "card_month": {
        "required": "Il mese di scadenza è richiesto"
    },
    "cvc_code": {
        "required": "Il codice di sicurezza (CVC) è richiesto",
        "invalid": "Il codice di sicurezza (CVC) non è valido"
    },
    "paypal_email": {
        "required": "L'email di Paypal è richiesta",
        "invalid": "L'email di Paypal non è valida"
    },
    "account_holder_name": {
        "required": "Il nome del titolare del conto bancario è richiesto"
    },
    "bank_name": {
        "required": "Il nome della banca è richiesto"
    },
    "bank_address": {
        "required": "L'indirizzo della banca è richiesto"
    },
    "preferred_payment_method": {
        "required": "Il metodo di pagamento preferito è richiesto"
    }
};

export default profileValidationIT;